import { Directive, inject, signal } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { ActivitiesService } from 'superlikers-microsites-api'

@Directive()
export class PhotoComponent {
  activitiesService = inject(ActivitiesService)

  imageUrl = signal<string | ArrayBuffer | null>(null)
  image = signal<File | null>(null)

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement
    const file = inputElement?.files?.[0]

    if (!file) return

    this.showImage(file)
    this.image.set(file)
  }

  showImage(file: File) {
    const reader = new FileReader()

    reader.onload = () => {
      this.imageUrl.set(reader.result)
    }

    reader.readAsDataURL(file)
  }

  async uploadPhoto(image: File, category: string) {
    try {
      const response$ = this.activitiesService.uploadPhoto({
        category,
        file: image
      })

      const response = await firstValueFrom(response$)
      if (response.state === 'error') throw new Error(response.message)
      console.log(response)
      return response.location
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Error inesperado'
      this.handleError?.(message)
      return
    }
  }

  protected handleError?(message: string): void
}
